import { render, staticRenderFns } from "./ProductDamage.vue?vue&type=template&id=e589051e&scoped=true&"
import script from "./ProductDamage.vue?vue&type=script&lang=js&"
export * from "./ProductDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e589051e",
  null
  
)

export default component.exports